import { EmployeeStats, PlaceBundle, PlaceEmployee, PlaceService } from '@/types/state/shared';

type SearchedService = PlaceService & { highlightedName: React.ReactNode };

type SearchedBundle = PlaceBundle & { highlightedName: React.ReactNode };

type PlacePageState = {
  search: string;
  showSearch: boolean;
  searchedServices: SearchedService[];
  searchedBundles: SearchedBundle[];
  employeeReviews?: { employee: PlaceEmployee; rating?: EmployeeStats[string] };
  isSticky?: boolean;
};

type PlacePageAction =
  | { type: 'REMOVE_SEARCH' }
  | { type: 'SHOW_SEARCH_INPUT' }
  | { type: 'CHANGE_SEARCH_INPUT'; value: string }
  | { type: 'CHANGE_SEARCHED_SERVICES'; payload: { services: SearchedService[]; bundles: SearchedBundle[] } }
  | { type: 'SET_EMPLOYEE_REVIEWS'; payload: { employee: PlaceEmployee; rating?: EmployeeStats[string] } }
  | { type: 'REMOVE_EMPLOYEE_REVIEWS' }
  | { type: 'SET_STICKY'; payload: boolean };

export default function placePageReducer(state: PlacePageState, action: PlacePageAction) {
  switch (action.type) {
    case 'REMOVE_SEARCH':
      return { ...state, search: '', showSearch: false, searchedServices: [], searchedBundles: [] };
    case 'SHOW_SEARCH_INPUT':
      return { ...state, showSearch: true };
    case 'CHANGE_SEARCH_INPUT':
      return { ...state, search: action.value };
    case 'CHANGE_SEARCHED_SERVICES':
      return {
        ...state,
        searchedServices: action.payload.services,
        searchedBundles: action.payload.bundles,
      };
    case 'SET_EMPLOYEE_REVIEWS':
      return {
        ...state,
        employeeReviews: action.payload,
      };
    case 'REMOVE_EMPLOYEE_REVIEWS':
      return {
        ...state,
        employeeReviews: undefined,
      };
    case 'SET_STICKY':
      return {
        ...state,
        isSticky: action.payload,
      };
    default:
      return state;
  }
}
